import type { MailboxInfo, MailboxType } from 'owa-client-types';

export enum LoadState {
    NotStarted,
    Loading,
    Loaded,
    Error,
}

export interface Characteristics {
    supportsCalendar: boolean;
    supportsContacts: boolean;
    supportsMail: boolean;
    supportsSettings: boolean;
    isMicrosoft365Hosted: boolean;
}

export enum M365AuthProvider {
    AAD,
    MSA,
}

export interface M365Mailbox {
    type: MailboxType;
    name: string;
    displayName: string;
    emailAddress: string;
    logonEmailAddress: string;
    userIdentity: string;
    routingHint: string;
    authProviderType: M365AuthProvider;
    alternateId: string;
    accountUniqueId: string;
    imageUrl: string;
    profileUrl: string;
    auxiliaryMailboxGuid?: string | null | undefined;
}

// Provides information about the state of the account
export interface AccountState {
    // The numeric value from the OWAConnectedAccountState in owa-account-store package, this
    // value will only be present for client-web applications that have not been migrated
    // to the Monarch multiple account infrastructure
    connectedAccountState: number;
}

// Specifies the source of the account information
export enum AccountSourceType {
    Office365 = 'Office365',
    OutlookDotCom = 'Outlook',
    Google = 'Google',
    ICloud = 'ICloud',
    Yahoo = 'Yahoo',
}

// The SharedAccountInfo interface contains information about the shared mailboxes associated with the source
export interface SharedAccountInfo {
    loadState: LoadState;
    sources: AccountSource[];
}

export interface AccountSource {
    sourceId: string;
    sourceType: AccountSourceType;
    displayName: string;
    characteristics: Characteristics;
    m365mailbox?: M365Mailbox;
    accountState?: AccountState;
    // If the account is a shared mailbox, the hostingSourceId will be the sourceId of the account
    // that is hosting this shared mailbox
    hostingSourceId?: string;
    sharedSources?: SharedAccountInfo;

    // For M3 we3 are also supporting the MailboxInfo structure for accounts, eventually this
    // will be removed and the UX will consume the sourceId, see task 118040
    mailboxInfo?: MailboxInfo;
}

export interface AccountSourceList {
    loadState: LoadState;
    globalSettingsSourceId: string;
    selectedSourceId: string;
    sources: AccountSource[];
    identities: string[]; // TODO: Identities need a separate store
}
